// extracted by mini-css-extract-plugin
export default {"container":"LanguageSlider_container__0WYuC"};